module.exports = __webpack_public_path__ + "static/media/img_editor_blbl.c955c2f2.jpeg";